import type { WidgetTabId } from '../../widgetConfig';
import type { JourneyWidgetPage, JourneyWidgetPageAction } from './pageState';

/**
 * The main navigation actions
 *
 * These are scoped by Activity and come from the shared page-stack reducer.
 */
export interface ActivityPageNavigation {
  showResults: () => void;
  showSearch: () => void;
  showPage: (page: JourneyWidgetPage) => void;
  goBack: () => void;
}

/**
 * Creates a set of navigation functions for an activity tab to use in its child pages.
 *
 * This means the child pages don't need to know about the page stack or the reducer.
 */
export function createActivityPageNavigation(
  dispatchPageState: (action: JourneyWidgetPageAction) => void,
  activityId: WidgetTabId,
): ActivityPageNavigation {
  return {
    showResults: () => {
      dispatchPageState({
        type: 'push-page',
        activityId,
        page: { kind: 'results' },
      });
    },
    showSearch: () => {
      dispatchPageState({
        type: 'reset-activity-stack',
        activityId,
      });
    },
    showPage: (page) => {
      dispatchPageState({
        type: 'push-page',
        activityId,
        page,
      });
    },
    goBack: () => {
      dispatchPageState({
        type: 'go-back',
        activityId,
      });
    },
  };
}
